import { server } from '@/constants';
import { useAppStore } from '@/stores/app';
import { toast } from '@nautilusbio/nb-design-system/Toaster';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useAuthStatus } from './useAuthStatus';

/**
 * Custom hook for handling user logout
 * Includes API call, navigation, and cache clearing
 */
export const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { signOut } = useAuthStatus();
  const { setIsSidebarMenuOpen, setSelectedOrganization } = useAppStore.getState();

  return useMutation<void, Error, void>({
    mutationFn: async () => {
      await fetch(`${server}/auth/logout`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        mode: 'cors',
      });

      await navigate({
        to: '/login',
        viewTransition: true,
      });

      signOut();
      // Reset zustand data
      setSelectedOrganization(undefined);
      setIsSidebarMenuOpen(false);
      // Clear the entire TanStack Query cache
      queryClient.clear();
    },
    onError: error => {
      console.error('Logout failed:', error);
      toast.error('Failed to logout. Please try again.');
    },
  });
};
